var e, a;
function t() {
  if (a) return e;
  a = 1;
  function r(s) {
    return this.__data__.has(s);
  }
  return e = r, e;
}
export {
  t as __require
};
